export const green = {
  green100: '#F3FCDC',
  green200: '#E5F9BB',
  green300: '#CCEC94',
  green400: '#B0DB75',
  green500: '#8BC34A',
  green600: '#6DA736',
  green700: '#538C25',
  green800: '#3B7117',
  green900: '#2A5D0E',
};
